import { useEffect, useState } from 'react';
import type { ContactRecord } from '@workspace/types';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

const MIN_REASON = 8;

export function ContactAgentRevokeOptOutDialog({
  contact,
  busy,
  onClose,
  onConfirm,
}: {
  contact: ContactRecord | null;
  busy: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}) {
  const [reason, setReason] = useState('');

  useEffect(() => {
    setReason('');
  }, [contact?.id]);

  const trimmed = reason.trim();
  const canSubmit = trimmed.length >= MIN_REASON && !busy;

  return (
    <Dialog open={Boolean(contact)} onOpenChange={open => (!open ? onClose() : undefined)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Revocar baja</DialogTitle>
          <DialogDescription>
            Solo si el cliente autorizó de nuevo por otro canal. Queda en auditoría. Las campañas
            ya enviadas no lo reencolan; sí queda disponible para contactos nuevos.
          </DialogDescription>
        </DialogHeader>
        {contact ? (
          <p className='text-sm text-muted-foreground'>
            {contact.businessName || contact.firstName || contact.phoneE164}
            {contact.optOutReason ? ` · Baja: ${contact.optOutReason}` : ''}
          </p>
        ) : null}
        <div className='space-y-2'>
          <Label htmlFor='revoke-opt-out-reason'>Cómo autorizó</Label>
          <Textarea
            id='revoke-opt-out-reason'
            maxLength={255}
            value={reason}
            onChange={event => setReason(event.target.value.slice(0, 255))}
            placeholder='Ej: Autorizó por teléfono el 23/08 con el asesor Juan'
          />
          <p className='text-xs text-muted-foreground'>Mínimo {MIN_REASON} caracteres.</p>
        </div>
        <DialogFooter>
          <Button type='button' variant='outline' onClick={onClose} disabled={busy}>
            Cancelar
          </Button>
          <Button type='button' disabled={!canSubmit} onClick={() => onConfirm(trimmed)}>
            Revocar baja
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
